import { useContext } from 'react'
import { FormCampaignContext, FormCampaignContextType } from '../context/FormCampaignContext'

export const useFormCampaignContext = (): FormCampaignContextType => {
  const context = useContext(FormCampaignContext)
  if (!context) {
    throw new Error('useFormularioClienteContext must be used within a HomePageProvider')
  }
  return context
}
